export default __webpack_public_path__ + "static/media/TheWorldBrazil_04.fb5265aa.png";